module.exports = __webpack_public_path__ + "static/media/NCA_old.e80fee38.jpg";